export default "__VITE_ASSET__DGWEMA26__"